import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiConfig } from './api.config';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ]
})
export class ApiEndpointModule {
  static forRoot(apiConfig: Partial<ApiConfig> = { }): ModuleWithProviders<ApiEndpointModule> {
    return {
      ngModule: ApiEndpointModule,
      providers: [{ provide: ApiConfig, useValue: apiConfig  }]
    };
  }
}
